<template>
  <v-container fluid>
    <User
      v-model="editUserItem"
      :saveCallback="onSaveUser"
    />

    <v-text-field
      dense
      v-model="search"
      append-icon="mdi-magnify"
      label="Поиск пользователя"
      single-line
      hide-details
      autocomplete="off"
      class="pb-4"
    ></v-text-field>

    <v-data-table
      dense
      :items="users"
      :headers="headers"
      :search="search"
      :loading="loading"
      :itemsPerPage="itemsPerPage"
      hide-default-footer
      @click:row="userClick"
      loading-text="Загрузка данных..."
      no-data-text="Нет данных..."
      no-results-text="Совпадений не найдено..."
      class="styled-table pointed-table"
    >
      <template v-slot:[`item.printOnDocs`]="{item}">
        <v-simple-checkbox
          class="checkbox"
          @click="userClick(item)"
          v-model="item.printOnDocs"
          disabled
        ></v-simple-checkbox>
      </template>

      <template v-slot:[`item.actions`]="{item}">
        <template v-if="item.role != 'Системный'">
          <v-icon
            @click.stop="deleteUser(item)"
            color="red"
          > mdi-delete </v-icon>
        </template>
      </template>
    </v-data-table>

    <!-- место для кнопки добавить -->
    <v-sheet height="64"></v-sheet>
    <!-- кнопка добавить -->
    <v-btn
      bottom
      right
      color="primary"
      dark
      fab
      fixed
      @click.prevent="addClick()"
      :loading="loading"
    >
      <v-icon class="white--text">mdi-plus</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import User from './User'

export default {
  data: () => ({
    // диалог с пользователем
    editUserItem: null,

    itemsPerPage: Number.MAX_SAFE_INTEGER,
    headers: [
      { text: 'Логин', value: 'login', align: 'start', class: 'tableHeader tableHeaderText--text' },
      { text: 'Фамилия Имя Отчество', value: 'name', class: 'tableHeader tableHeaderText--text' },
      { text: 'Роль', value: 'role', class: 'tableHeader tableHeaderText--text' },
      {
        text: 'Доверенность',
        align: 'center',
        sortable: false,
        width: '100px',
        value: 'printOnDocs',
        class: 'tableHeader tableHeaderText--text'
      },
      { text: '', value: 'actions', sortable: false, width: '48px', class: 'tableHeader tableHeaderText--text' }
    ],
    search: '',
    loading: false,
    users: []
  }),

  methods: {
    getItems () {
      this.loading = true
      this.axios
        .get('/users/get')
        .then(response => {
          this.users = response.data
          this.loading = false
        })
        .catch(() => {
          this.$router.push('/error?message=Ошибка при загрузке пользователей')
        })
    },

    /// //////// РЕДАКТИРОВАНИЕ //////// ///
    keydown (value) {
      if (value.code === 'NumpadAdd') {
        this.addClick()
      }
    },

    // редактирование
    userClick (user) {
      this.editUserItem = user
    },

    async deleteUser (user) {
      if (!(await this.$messageBox(`Удалить пользователя <span class="accent--text">${user.name}</span> ?`))) return
      this.loading = true
      this.axios
        .delete(`/users/delete/${user.id}`)
        
        // eslint-disable-next-line no-unused-vars
        .then(_ => {
          this.users.splice(this.users.indexOf(user), 1)
        })
        .catch(err => {
          this.$notify(
            'error',
            err.response?.data?.message ? err.response.data.message : 'Ошибка при удалении пользователя'
          )
        })
        .finally(() => {
          this.loading = false
        })
    },

    // открыть диалог добавления
    addClick () {
      this.editUserItem = {}
    },

    // сохранение
    async onSaveUser (user) {
      return user.id < 0 ? await this.insertUser(user) : await this.updateUser(user)
    },

    async updateUser (user) {
      return this.axios
        .put('/users/update', { ...user })
        .then(() => {
          this.getItems()
          return true
        })
        .catch(err => {
          this.$notify(
            'error',
            err.response?.data?.message ? err.response.data.message : 'Ошибка при изменении пользователя'
          )
          return false
        })
    },

    async insertUser (user) {
      return this.axios
        .post('/users/insert', { ...user })
        .then(() => {
          this.getItems()
          return true
        })
        .catch(err => {
          this.$notify(
            'error',
            err.response?.data?.message ? err.response.data.message : 'Ошибка при добавлении пользователя'
          )
          return false
        })
    }
    /// //////// РЕДАКТИРОВАНИЕ //////// ///
  },

  beforeDestroy () {
    document.removeEventListener('keydown', this.keydown)
  },

  created () {
    document.addEventListener('keydown', this.keydown)

    // столбец с типом груза только для тех, кто видит разные
    if (!this.$store.state.auth.user.cargoTypeID) {
      this.headers.splice(this.headers.length - 1, 0, {
        text: 'Тип груза',
        align: 'center',
        value: 'cargoType.name',
        class: 'tableHeader tableHeaderText--text'
      })
    }

    this.getItems()
  },

  components: {
    User
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  cursor: pointer;
  & > .v-icon.v-icon.v-icon--disabled {
    color: inherit !important;
  }
}
</style>
